import { render } from "./NurseryOpus.vue?vue&type=template&id=27c8c4f1&scoped=true"
import script from "./NurseryOpus.vue?vue&type=script&lang=js"
export * from "./NurseryOpus.vue?vue&type=script&lang=js"

import "./NurseryOpus.vue?vue&type=style&index=0&id=27c8c4f1&lang=scss&scoped=true"

import exportComponent from "/apps/srv/jenkins/workspace/feihua_fe_mguoxueweb_online/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c8c4f1"]])

export default __exports__